import React from "react";
import { Alert, Form, Button, Card, Row } from 'react-bootstrap';
import { ArrowUp } from 'react-feather';
import { Link } from 'react-router-dom';
import PropTypes from "prop-types";

import './UploadCSV.scss';

function UploadCSV(props) {
	const { children, file, importStatusLink, submitStatus: { success, error, uploading }, breadcrumb, deprecated } = props;
	const { onSubmit, onSetFile } = props;

	const onFileChange = (ev) => {
		onSetFile(ev.target.files[0]);
	}

	return (
		<>
			{breadcrumb}
			<Card>
			<Card.Header>
				{deprecated && <Alert variant="warning"><div className="m-2">{deprecated}</div></Alert>}
				{success && <AlertMessage variant="success" message="File uploaded successfully" />}
				{error && <AlertMessage variant="danger" message={error} />}
				<Form>
					<Form.Group as={Row} className="file-upload" id="formFile">
						<Form.Control type="file" onChange={onFileChange} id="uploadFile" disabled={deprecated}/>
						<Button className="button-upload" disabled={deprecated || !file || uploading} onClick={onSubmit}>Upload <ArrowUp width={22} height={22} /></Button>
					</Form.Group>
				</Form>
				<br />
				{importStatusLink && <Link to={importStatusLink}>View uploaded files status</Link>}
			</Card.Header>
			<Card.Body>
				<>
					<p>The file must be a <strong>.csv</strong> file separated by comma and encoded as <strong>utf-8</strong>, in addition you can encode as utf-16 or utf-32 if you include a <a title="Byte order mark" href="http://www.unicode.org/faq/utf_bom.html#BOM" target="_blank" rel="noreferrer">BOM</a></p>
					{children}
				</>
			</Card.Body>
		</Card>
		</>
	);
}


function AlertMessage(props) {
	const { message, variant } = props;

	const body = message.split("\n").map(error => <p>{error}</p>);
	return (
		<Alert variant={variant}>{
			<p className='m-2'>{body}</p>
		}</Alert>
	);
}

UploadCSV.propTypes = {
	children: PropTypes.element,
	breadcrumb: PropTypes.element,
	onSubmit: PropTypes.func.isRequired,
	onSetFile: PropTypes.func.isRequired,
	file: PropTypes.instanceOf(File),
	deprecated: PropTypes.node,
	importStatusLink: PropTypes.string,
	submitStatus: PropTypes.shape({
		success: PropTypes.bool,
		uploading: PropTypes.bool,
		error: PropTypes.string
	})
}

export default UploadCSV;
